import React, { useEffect, useState } from "react";
import axios from "axios";

const CostDriverAdmin = () => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ costDriver: "", supportDocuments: "" });
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchList();
  }, []);

  const fetchList = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/CostDriverOptions`);

      if (Array.isArray(data)) {
        setItems(data);
      } else if (data && Array.isArray(data.$values)) {
        setItems(data.$values);
      } else {
        setItems([]);
        setError("Invalid data format received.");
      }

    } catch {
      setError("Failed to load cost drivers.");
    }
  };

  const clearForm = () => {
    setForm({ costDriver: "", supportDocuments: "" });
    setEditId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/CostDriverOptions/${editId}`, {
          id: editId,
          ...form
        });
      } else {
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CostDriverOptions`, form);
      }
      fetchList();
      clearForm();
    } catch {
      setError("Error saving cost driver.");
    }
  };

  const handleEdit = (item) => {
    setEditId(item.id);
    setForm({
      costDriver: item.costDriver,
      supportDocuments: item.supportDocuments
    });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Permanently delete?")) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/CostDriverOptions/${id}`);
        fetchList();
      } catch {
        setError("Delete failed.");
      }
    }
  };

  return (
    <div className="container my-4">
      <h2>Manage Cost Drivers</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit} className="mb-3">
        <div className="form-row">
          <div className="col">
            <input
              type="text"
              name="costDriver"
              className="form-control"
              placeholder="Cost Driver"
              value={form.costDriver}
              onChange={e => setForm({ ...form, costDriver: e.target.value })}
              required
            />
          </div>
          <div className="col">
            <input
              type="text"
              name="supportDocuments"
              className="form-control"
              placeholder="Support Documents"
              value={form.supportDocuments}
              onChange={e => setForm({ ...form, supportDocuments: e.target.value })}
              required
            />
          </div>
          <div className="col-auto">
            <button type="submit" className="btn btn-primary">
              {editId ? "Update" : "Add"}
            </button>
            {editId && (
              <button
                type="button"
                className="btn btn-secondary ml-2"
                onClick={clearForm}
              >
                Cancel
              </button>
            )}
          </div>
        </div>
      </form>

      <table className="table table-striped">
        <thead>
          <tr>
            <th>Cost Driver</th>
            <th>Support Documents</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map(item => (
            <tr key={item.id}>
              <td>{item.costDriver}</td>
              <td>{item.supportDocuments}</td>
              <td>
                <button className="btn btn-sm btn-warning mr-2" onClick={() => handleEdit(item)}>
                  Edit
                </button>
                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
          {items.length === 0 && (
            <tr><td colSpan="3">No cost drivers available.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CostDriverAdmin;
